/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.btn.btn-secondary[_ngcontent-%COMP%]{position:relative;right:unset;bottom:unset}.form-row[_ngcontent-%COMP%]   .one-field[_ngcontent-%COMP%]{flex:unset;width:100%}.two-cols-wrap[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]{flex-direction:column}.two-cols-wrap[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]   .get-credentials-info[_ngcontent-%COMP%]{margin:20px 0;font-size:18px;line-height:1.1;color:#4ea046}"];
export { styles as styles };
